import api from "./es-ES/api";
import appName from "./es-ES/appName";
import attendanceCards from "./es-ES/attendanceCards";
import attendanceOptions from "./es-ES/attendanceOptions";
import attendanceTypes from "./es-ES/attendanceTypes";
import auth from "./es-ES/auth";
import billing from "./es-ES/billing";
import chat from "./es-ES/chat";
import common from "./es-ES/common";
import contacts from "./es-ES/contacts";
import dashboard from "./es-ES/dashboard";
import displayMessages from "./es-ES/displayMessages";
import eventTimeline from "./es-ES/eventTimeline";
import financial from "./es-ES/financial";
import functions from "./es-ES/functions";
import guides from "./es-ES/guides";
import home from "./es-ES/home";
import import_ from "./es-ES/import";
import journeyStages from "./es-ES/journeyStages";
import landing from "./es-ES/landing";
import landingHome from "./es-ES/landingHome";
import memberGroup from "./es-ES/memberGroup";
import memberHistory from "./es-ES/memberHistory";
import membersAssignments from "./es-ES/membersAssignments";
import mfa from "./es-ES/mfa";
import menu from "./es-ES/menu";
import navigation from "./es-ES/navigation";
import notFound from "./es-ES/notFound";
import onboarding from "./es-ES/onboarding";
import orixas from "./es-ES/orixas";
import pagination from "./es-ES/pagination";
import people from "./es-ES/people";
import personGuides from "./es-ES/personGuides";
import personMessage from "./es-ES/personMessage";
import personReturn from "./es-ES/personReturn";
import persons from "./es-ES/persons";
import profile from "./es-ES/profile";
import registerInvite from "./es-ES/registerInvite";
import registerTemple from "./es-ES/registerTemple";
import reports from "./es-ES/reports";
import ritualAttendance from "./es-ES/ritualAttendance";
import ritualClosing from "./es-ES/ritualClosing";
import ritualTypes from "./es-ES/ritualTypes";
import rituals from "./es-ES/rituals";
import ritualReservations from "./es-ES/ritualReservations";
import spiritualLines from "./es-ES/spiritualLines";
import support from "./es-ES/support";
import table from "./es-ES/table";
import temple from "./es-ES/temple";
import agendaPublica from "./es-ES/agendaPublica";
import themes from "./es-ES/themes";
import ticketCall from "./es-ES/ticketCall";
import tickets from "./es-ES/tickets";
import tours from "./es-ES/tours";
import users from "./es-ES/users";
import ownershipTransfer from "./es-ES/ownershipTransfer";
import validation from "./es-ES/validation";
import phoneField from "./es-ES/phoneField";
import verifyEmail from "./es-ES/verifyEmail";
import wisdomQuotes from "./es-ES/wisdomQuotes";
import session from "./es-ES/session";

export default {
	relatedEntityCreation: {
		createSpiritualLine: "+ Crear Línea Espiritual",
		createGuide: "+ Crear Guía",
		createAttendanceType: "+ Crear Tipo de Atención",
		createRitualType: "+ Crear Tipo de Ritual",
		createMedium: "+ Crear Médium",
	},
	locale: "es-ES",
	appName,
	api,
	attendanceCards,
	attendanceOptions,
	attendanceTypes,
	auth,
	billing,
	common,
	contacts,
	dashboard,
	displayMessages,
	eventTimeline,
	financial,
	functions,
	guides,
	home,
	import: import_,
	journeyStages,
	landing,
	landingHome,
	memberGroup,
	memberHistory,
	membersAssignments,
	mfa,
	chat,
	menu,
	navigation,
	notFound,
	onboarding,
	orixas,
	pagination,
	people,
	personGuides,
	personMessage,
	personReturn,
	persons,
	profile,
	registerInvite,
	registerTemple,
	reports,
	ritualAttendance,
	ritualClosing,
	ritualTypes,
	rituals,
	ritualReservations,
	spiritualLines,
	support,
	table,
	temple,
	agendaPublica,
	themes,
	ticketCall,
	tickets,
	tours,
	users,
	ownershipTransfer,
	validation,
	phoneField,
	verifyEmail,
	wisdomQuotes,
	session,
};
